import React from 'react';
import _ from 'lodash';
import moment from 'moment';

const cc = require('cryptocompare');
cc.setApiKey('<73ccea7c5f0453fc9ee58fc97ac6e42476785745cf50545a56e8bf085613f0f5>');

export const AppContext = React.createContext();

const MAX_FAVORITES = 10;
const TIME_UNITS = 10;

export class AppProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 'dashboard',
      dummy: ['BTC', 'ETH', 'XMR', 'DOGE'],
      favorites: ['BTC', 'ETH', 'XMR', 'DOGE'],
      prices: [],
      currentFavorite: '',
      timeInterval: 'months', 
      setPage: this.setPage,
      addCoin: this.addCoin,
      removeCoin: this.removeCoin,
      isInFavorites: this.isInFavorites,
      confirmFavorites: this.confirmFavorites,
      setCurrentFavorite: this.setCurrentFavorite,
      setFilteredCoins: this.setFilteredCoins,
      ...this.savedSettings(),
      changeChartSelect: this.changeChartSelect
    }
  }

  componentDidMount = () => {
    this.fetchCoins();
    //console.log(this.state.page, this.state.dummy);
    //this.setState({favorites: ['BTC', 'ETH', 'XMR', 'DOGE']}, console.log(this.state.favorites));
    this.fetchPrices();
    this.fetchHistorical();
  }

  fetchCoins = async () => {
    let coinList = (await cc.coinList()).Data;
    this.setState({coinList});
    //console.log(coinList);
  }

  // Add fetchPrices Function
  fetchPrices = async () => {
    console.log("1========>")
    // if(this.state.firstVisit) return;
    console.log("2========>")
    // get prices from another function named 'prices'
    let prices = await this.prices();
    // console.log(prices);
    // we must filter the empty price objects 
    prices = prices.filter(price => Object.keys(price).length);
    this.setState({prices});
    console.log('Favourite===>', this.state.currentFavorite);
  }

  // Add fetchHistorical function
  fetchHistorical = async () => {
    //first, make sure the user is not the firstVisitor state
    //=> // if this is NOT firstVisit, just return
    if (this.state.firstVisit) return;
    // if NOT firstVisit, means we DO have currentFavorite
    let results = await this.historical();
    //try to log the results
    //console.log('results', results);
    let historical = [
      {
        name: this.state.currentFavorite,
        data: results.map((ticker, index) => [
          // we wanna build historical array
          moment().subtract({[this.state.timeInterval]: TIME_UNITS - index}).valueOf(),
          //y-axis value
          ticker.USD
        ])

        

      }
    ]
    this.setState({historical});
  }


  // Let's create the Helper Function named 'prices' which is another 'async' function
  prices = async () => {
    let returnData = [];
    for (let i = 0; i < this.state.dummy.length; i++) {
      // add 'try...catch' block here
      try {
        let priceData = await cc.priceFull(this.state.dummy[i], 'USD');
        console.log("priceData===>", priceData)
        returnData.push(priceData);
      } catch (e) {
        console.warn('Fetch price error: ', e);
      }
    }
    return returnData;
  }

  // Add new Function here, named 'historical'
  historical = () => {
    let promises = [];
    // loop thru these units
    for ( let units = TIME_UNITS; units > 0; units --) {
      promises.push(
        // push to price historical function
        cc.priceHistorical(
          this.state.currentFavorite,
          ['USD'],
          moment()
            .subtract({[this.state.timeInterval]: units})
            .toDate()
        )
      )
    }
    return Promise.all(promises);
  }

  addCoin = key => {
    // let favorites = [...this.state.favorites];
    let dummy = [...this.state.dummy];
    if(dummy.length < MAX_FAVORITES) {
      dummy.push(key);
      this.setState({dummy});
    }
  }

  removeCoin = key => {
    console.log('Remove coin===>', key)
    let dummy = [...this.state.dummy];
    // this.setState({favorites: _.pull(favorites, key)})
    
    let checkIndex = dummy.indexOf(key);
    console.log('dummy===>', dummy, checkIndex)
    dummy.splice(checkIndex, 1);
    console.log('Remove dummy===>', dummy)
    this.setState({dummy});
  }

  isInFavorites = key => _.includes(this.state.dummy, key)

  confirmFavorites = () => {
    // check conditional: length of this.state.dummy > 0 {...} else if {disable comfrimFavorite Button}
    // add additional line of code below
    let currentFavorite = this.state.dummy[0];//triggered
  
    console.log('Hello =====>', currentFavorite);
    this.setState({
      firstVisit: false,
      page: 'dashboard',
      currentFavorite,
      prices: null,
      historical: null
    }, () => {
        this.fetchPrices();
        this.fetchHistorical();
    });
    // Add localStorage Function
    localStorage.setItem('cryptoDash', JSON.stringify({
      dummy: this.state.dummy,
      currentFavorite
    }));
  }

  //create new function named 'setCurrentFavorite'
  setCurrentFavorite = (sym) => {
    console.log("sym====>", sym)
    this.setState({
      currentFavorite: sym,
      historical: null
    }, this.fetchHistorical);
    //once we click, set the localStorage as well
    localStorage.setItem('crypto', JSON.stringify({
      ...JSON.parse(localStorage.getItem('cryptoDash')),
      currentFavorite: sym
    }))
  }

  savedSettings () {
    let cryptoDashData = JSON.parse(localStorage.getItem('cryptoDash'));
    if(!cryptoDashData) {
      return {page: 'settings', firstVisit: true}
    }
    let {dummy, currentFavorite} = cryptoDashData;
    return {dummy, currentFavorite};
  }

  setPage = page => this.setState({page})

  

  setFilteredCoins = (filteredCoins) => this.setState({filteredCoins})

  changeChartSelect = (value) => {
    console.log(value);
    this.setState({timeInterval: value, historical: null}, this.fetchHistorical);
  }

  render(){
    return (
      <AppContext.Provider value={this.state}>
        {this.props.children}
      </AppContext.Provider>
    )
  }
  
}